// Shared intensity ramp + level bucketing for the activity heatmap and the
// best-time clock, so both read identically across views.
export const HEAT = [
  'bg-base-content/12',
  'bg-primary/45',
  'bg-primary/65',
  'bg-primary/85',
  'bg-primary',
];

export function heatLevel(total: number, max: number): number {
  if (total <= 0 || max <= 0) return 0;
  const r = total / max;
  return r > 0.75 ? 4 : r > 0.5 ? 3 : r > 0.25 ? 2 : 1;
}
